import { IncentiveOffer } from 'modules/incentivesMarket/types';

import { isOfferActive } from './getOfferStatus';

export const filterOffersForListView = (
  offers: IncentiveOffer[],
  { isBeneficiaryView }: { isBeneficiaryView: boolean }
): IncentiveOffer[] =>
  isBeneficiaryView ? offers.filter(isOfferActive) : offers;
